import React from 'react';
import { withRouter, useLocation } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import logo from '../../../image/logo.png';
import CustomLinkedIN from '../../Linkdin/CustomLinkedIN.js'
import { reqUestDeniedByCity } from '../../../actions/FindRecCompany.js';
import { unreadNotificationListAction, notiFiactionListAction, notificationStatusChangeAction } from '../../../actions/Notifications';
import '../../../index.css';
import { appConstantsSocket } from '../../../_constants';
import 'font-awesome/css/font-awesome.min.css';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            header: "",
            unReadMessageCount: 0,
            signUpBtn: true,
            search: true,
            chatSectionModule: false,
            notificationList: [],
            unreadNotificationCount: 0,
            userData: JSON.parse(localStorage.getItem('userData'))
        };
        this.chatFunction = this.chatFunction.bind(this);
        let _this = this;
        appConstantsSocket.socket.on('chatBatchCount', function (newChatCount) {
            _this.setState({
                unReadMessageCount: newChatCount.unReadMessageCount
            })
        })

    }

    // componentDidMount() {
    //   // let loc = useLocation();split('~');
    //    console.log("loc",this.props.match.path.split(':'))
    // }
    componentWillMount() {

        const { userData } = this.state
        if (localStorage.getItem('userLogin') === "true" && userData.userType !== "admin") {
            this.setState({
                signOutBtn: true,
                signUpBtn: false
            });

            if (userData.userType === "company") {
                appConstantsSocket.socket.emit('addCompany', { id: userData._id });
            }

            if (userData.userType === "recruiter") {
                appConstantsSocket.socket.emit('addRecruter', { id: userData._id });
            }

            if (userData.userType === "user") {
                appConstantsSocket.socket.emit('addUser', { id: userData._id });
            }

            let _this = this;
            appConstantsSocket.socket.emit('getchatCount', { id: userData._id });
            appConstantsSocket.socket.on('chatBatchCount', function (newChatCount) {
                _this.setState({
                    unReadMessageCount: newChatCount.unReadMessageCount
                })

            });

            this.props.unreadNotificationListAction();
            this.props.notiFiactionListAction();
        }

        if (window.location.pathname === "/sign-up") {
            this.setState({
                signUpBtn: false
            })
        }
    }

    shouldComponentUpdate(nextProps, nextState) {

        if ((this.state.userData === undefined || this.state.userData === null) && JSON.parse(localStorage.getItem('userData'))) {
            this.setState({
                userData: JSON.parse(localStorage.getItem('userData'))
            })
            let userDetail = JSON.parse(localStorage.getItem('userData'));
            if (localStorage.getItem('userLogin') === "true" && userDetail.userType !== "admin") {
                this.setState({
                    signOutBtn: true,
                    signUpBtn: false
                })
                this.props.unreadNotificationListAction();
                this.props.notiFiactionListAction();
            }
            return true;
        }
        return true;
    }

    componentWillReceiveProps(nextProps) {

        const { userData } = this.state;
        if (nextProps && nextProps.notificationType === "statusChnage" && nextProps.notification.statusCode === 200) {
            this.props.unreadNotificationListAction();
        }
        if (nextProps.notification && nextProps.notification.statusCode === 200 && nextProps.notification.unReadCount) {
            this.setState({
                unreadNotificationCount: nextProps.notification.unReadCount
            })
        }
        if (nextProps.notification && nextProps.notification.statusCode === 200 && nextProps.notification.data && nextProps.notification.data.data && nextProps.notification.data.data.length > 0) {
            this.setState({
                notificationList: nextProps.notification.data.data
            })
        }

        if (localStorage.getItem('userLogin') === "true" && userData && userData.userType !== "admin") {
            this.setState({
                userData: JSON.parse(localStorage.getItem('userData')),
                signOutBtn: true,
                signUpBtn: false
            })
        }
    }

    signUp = () => {
        this.props.history.push({
            pathname: "/sign-up",
            state: { "fieldSelct": this.state.fieldSelct }
        });
    }

    signUpEmail = () => {
        this.props.history.push({
            pathname: "/signUp",
            state: { "fieldSelct": {} }
        });
    }

    signOut = () => {
        localStorage.removeItem('userLogin')
        localStorage.removeItem('userData')
        this.props.history.push({
            pathname: "/",
            state: { "fieldSelct": this.state.fieldSelct }
        });
        window.location.reload();
    }

    chatFunction() {
        let _this = this;
        var redirectProfile = "";
        if (this.state.userData && this.state.userData.userType === "user") {
            redirectProfile = "/user-profile"
        } else {
            redirectProfile = "/account-detail"
        }
        this.props.history.push({
            pathname: redirectProfile,
            state: { "chatSectionModule": true }
        });
    }

    logoRedirect = () => {
        const { userData } = this.state
        if (userData) {
            if (this.state.userData.userType === "user") {
                this.props.history.push({
                    pathname: "/",
                    state: { "fieldSelct": this.state.fieldSelct }
                });
            } else if (userData.userType === "company" || userData.userType === "recruiter" || userData.userType === "subUser") {
                this.props.history.push({
                    pathname: "/dashboard-home",
                    state: { "fieldSelct": this.state.fieldSelct }
                });
            } else {
                this.props.history.push({
                    pathname: "/",
                    state: { "fieldSelct": this.state.fieldSelct }
                });
            }
        } else {
            this.props.history.push({
                pathname: "/",
                state: { "fieldSelct": this.state.fieldSelct }
            });
        }
    }

    changenNotificationStatus = () => {
        let reqParams = {
            "id": this.state.userData._id,
            "status": "read"
        }

        this.props.notificationStatusChangeAction(reqParams)
        if (document.getElementById("msgDropDown").style.display === "block") {
            document.getElementById("msgDropDown").style.display = "none";
        } else {
            document.getElementById("msgDropDown").style.display = "block";
        }
    }

    signIn = () => {
        let locationPath = this.props.location.pathname;
        this.props.history.push({
            pathname: "/sign-in",
            state: { "fieldSelct": this.state.fieldSelct, redirectPath: locationPath }
        });
    }

    blogs = () => {
        this.props.history.push({
            pathname: "/blog",
        });
    }

    handleMobileOption = () => {
        if (document.getElementById("toogleSignOut").style.display === "block") {
            document.getElementById("toogleSignOut").style.display = "none";
        } else {
            document.getElementById("toogleSignOut").style.display = "block";
        }

    }

    userProFile = () => {
        var redirectProfile = "";
        if (this.state.userData && this.state.userData.userType === "user") {
            redirectProfile = "/user-profile"
        } else {
            redirectProfile = "/account-detail"
        }
        this.props.history.push({
            pathname: redirectProfile,
            state: { "fieldSelct": this.state.fieldSelct, "chatSectionModule": false }
        });
    }

    render() {
        const { noLeftBar } = this.props;
        const { signOutBtn, userData, unreadNotificationCount, notificationList, unReadMessageCount } = this.state

        return (

            <div className="topnav">
                <div className="container" >
                    <div className="row display-row">
                        <div className="col-md-6 col-6 col-sm-6">
                            <div className="logo-box" onClick={this.logoRedirect}>
                                <img src={logo} alt="logo" />
                            </div>
                        </div>
                        {!noLeftBar &&

                            <div className="col-md-6 col-6 col-sm-6 button-align">

                                <ul class="clearfix footerSocial">
                                    <li>
                                        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/A-Right-Connection-351774465896348">
                                            <i class="fa fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/arightconnection/">
                                            <i class="fa fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/arightconnection/">
                                            <i class="fa fa-linkedin"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/ARightConnect">
                                            <i class="fa fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a target="_blank" rel="noopener noreferrer" href="https://www.pinterest.com/rightconnectionla/">
                                            <i class="fa fa-pinterest"></i>
                                        </a>
                                    </li>
                                </ul>

                                {!signOutBtn &&
                                    <span>

                                        <div className="input-group Drop-btn">
                                            <div className="input-group-append">
                                                <button className="btn btn-outline-secondary signInHeder dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Sign Up</button>&nbsp;&nbsp;
                                                <div class="dropdown-menu">
                                                    <button className="btn btn-signIn drop-Signin" title="Sign In" onClick={this.signUpEmail}><i className="fa fa-sign-in"></i> Sign Up with Email</button>
                                                    <CustomLinkedIN textTtile={"Sign Up with LinkedIn"} props={this.props} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="input-group Drop-btn">
                                            <div className="input-group-append">
                                                <button className="btn btn-outline-secondary signInHeder dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Log In</button>&nbsp;&nbsp;
                                                <div class="dropdown-menu">
                                                    <button className="btn btn-signIn drop-Signin" title="Sign In" onClick={this.signIn}><i className="fa fa-sign-in"></i> Log In with Email</button>
                                                    <CustomLinkedIN textTtile={"Log In with LinkedIn"} props={this.props} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="input-group Drop-btn">
                                            <div className="input-group-append">
                                                <button className="btn btn-outline-secondary signInHeder dropdown-toggle" type="button" onClick={this.blogs}>Blogs</button>&nbsp;&nbsp;
                                            </div>
                                        </div>
                                    </span>

                                    /*<div className=""> 
                                        <button className="btn btn-signIn " title="Sign In" onClick={this.signIn}>
                                               <i className="fa fa-sign-in"></i> Sign-In
                                        </button>
                                                                          
                                        <CustomLinkedIN textTtile={"Sign in with LinkedIn"} props={ this.props }/>
                                    </div>*/
                                }
                                {signOutBtn &&
                                    <div>
                                        <div className="user-profile-block-desktop">
                                            <span className="desktop-user-block" onClick={this.userProFile} >

                                                <img src={userData.image ? process.env.REACT_APP_SERVER_IMAGE_BUCKET + "/" + userData.image : process.env.REACT_APP_USER_ICON_IMAGE} alt="new" className="desktop-userIcon" />
                                                {/*<i className="fa fa-user desktop-userIcon"></i>*/}
                                                <span className="user-name">{userData.firstName}</span>
                                            </span>

                                            <span onClick={e => { this.chatFunction(e) }}>
                                                <a className="chatIcon siz-chatico">
                                                    <i className="fa fa-comments"></i>
                                                </a>
                                                {unReadMessageCount !== 0 &&
                                                    <span className="circle-chats">{unReadMessageCount}</span>
                                                }
                                            </span>
                                            <div className="notification-block">
                                                <div className="bell-box">
                                                    <i className="fa fa-bell-o" onClick={this.changenNotificationStatus}></i>
                                                    {unreadNotificationCount > 0 &&
                                                        <span className="msg-count">{unreadNotificationCount}</span>
                                                    }
                                                    <div className="msg-drop-down" id="msgDropDown">
                                                        <div className="msg-listing">
                                                            <h4 className="notiyf">Notifications</h4>
                                                            <div className="padd15">
                                                                {notificationList.map((data, index) => (
                                                                    <div key={index} className={"notification" + data.readStatus}>{data.title}</div>

                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <a className="btn sign-out-btn" onClick={this.signOut}>Log Out</a>
                                        </div>

                                        <div className="user-profile-block user-profile-block-mobile">
                                            <a className="mobile-user-block" onClick={this.handleMobileOption} >
                                                <i className="fa fa-user userIcon"></i>
                                                <span className="user-name">{userData.firstName}</span>
                                            </a>
                                            <div className="user-dropdown-menu" id="toogleSignOut">
                                                <a className="profile-menu-item" onClick={this.userProFile}><i className="fa fa-eye"></i> View Profile</a>
                                                <a className="profile-menu-item" onClick={this.signOut} ><i className="fa fa-sign-out"></i> Log Out</a>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        notification: state.Notification.response,
        notificationType: state.Notification.type,
    }
}

export default withLocalize(withRouter(connect(mapStateToProps, {
    reqUestDeniedByCity,
    unreadNotificationListAction,
    notificationStatusChangeAction,
    notiFiactionListAction
})(Header)));


// WEBPACK FOOTER //
// ./src/components/Inc/Layout/Header.js